module.exports = __webpack_public_path__ + "static/media/finger_white.8e523535.svg";